export default [
  {
    name: "Monitor",
    dataTarget: "Monitor section",
    translationKey: "common.monitor",
    icon: ["fal", "fa-user-chart"],
    isPrefix: true,
    subRoutes: [
      {
        id: 1,
        translationKey: "navbar.monitor.search",
        path: "/search",
        isExternalRoute: false,
        display: false,
        dataTarget: "Search Page",
      },
      {
        id: 17,
        translationKey: "navbar.manage.manageSearch",
        path: "/manage",
        isExternalRoute: true,
        display: true,
        dataTarget: "Manage Searches page",
      },
      {
        id: 2,
        translationKey: "common.mentions",
        path: "/mentions",
        isExternalRoute: false,
        display: false,
        dataTarget: "Mentions page",
      },
      {
        id: 3,
        translationKey: "common.topics",
        path: "/topics",
        isExternalRoute: false,
        display: false,
        dataTarget: "Topics page",
      },
      {
        id: 4,
        translationKey: "navbar.monitor.chartAnalytics",
        path: "/charts",
        isExternalRoute: false,
        display: false,
        dataTarget: "Chart Analytics Page",
      },
    ],
  },
  {
    name: "Reports",
    dataTarget: "Reports section",
    translationKey: "common.reports",
    icon: ["fal", "fa-file-chart-line"],
    isPrefix: true,
    subRoutes: [
      {
        id: 7,
        translationKey: "common.reports",
        path: "/reports#/list",
        isExternalRoute: true,
        display: true,
        dataTarget: "Reports Page",
      },
      {
        id: 19,
        translationKey: "common.templates",
        path: "/reports#/templates",
        isExternalRoute: true,
        display: true,
        dataTarget: "Templates page",
      },
    ],
  },
  {
    name: "Contacts",
    dataTarget: "Contacts section",
    translationKey: "common.contacts",
    icon: ["fal", "fa-book-user"],
    isPrefix: true,
    subRoutes: [],
  },
  {
    name: "Manage",
    dataTarget: "Manage Section",
    translationKey: "common.manage",
    icon: ["fal", "fa-sliders"],
    isPrefix: true,
    subRoutes: [
      {
        id: 12,
        translationKey: "navbar.manage.targetMediaLists",
        path: "/target-media-lists",
        isExternalRoute: false,
        dataTarget: "TML page",
        display: false,
      },
      {
        id: 14,
        translationKey: "common.alerts",
        path: "/alerts/real-time",
        isExternalRoute: true,
        dataTarget: "Alerts page",
        display: false,
      },
      {
        id: 15,
        translationKey: "navbar.manage.mentionsAndPublications",
        path: "/manage/added-mentions",
        isExternalRoute: false,
        dataTarget: "Mentions & Publications page",
        display: true,
      },
    ],
  },
  {
    name: "Social",
    dataTarget: "Social Media Accounts",
    translationKey: "sidebar.social",
    icon: ["fac", "media-link"],
    isPrefix: true,
    subRoutes: [
      {
        id: 16,
        translationKey: "sidebar.social",
        path: "/social",
        isExternalRoute: false,
        display: true,
      },
    ],
  },
  {
    name: "Settings",
    dataTarget: "Settings Section",
    translationKey: "sidebar.settings",
    icon: ["fal", "cog"],
    isPrefix: false,
    subRoutes: [
      {
        id: 16,
        translationKey: "navbar.monitor.settings",
        path: "/settings",
        isExternalRoute: false,
        display: true,
      },
    ],
  },
  {
    name: "Help",
    dataTarget: "Help Button",
    translationKey: "sidebar.help",
    icon: ["fal", "circle-question"],
    isPrefix: false,
    subRoutes: [],
  },
  {
    name: "ExitUser",
    dataTarget: "",
    translationKey: "sidebar.logout",
    icon: ["fal", "fa-sign-out"],
    isPrefix: false,
    subRoutes: [],
  },
];
